import { cn } from "@/lib/utils";
import { cardTypeConfig } from "@/pages/Home/card/view/_components/cardTypeConfig";
import { mapTransactionCardType } from "./mapTransactionCardType";

type Props = {
	cardType: string | null | undefined;
	last4: string | null | undefined;
	className?: string;
};

function hasCardInfo(
	cardType: string | null | undefined,
	last4: string | null | undefined,
): boolean {
	return Boolean(cardType?.trim() || last4?.trim());
}

const TransactionPaymentMethod = ({ cardType, last4, className }: Props) => {
	if (!hasCardInfo(cardType, last4)) {
		return (
			<span className={cn("text-sm font-medium text-textLight", className)}>
				—
			</span>
		);
	}

	const normalizedType = mapTransactionCardType(cardType);
	const Icon = cardTypeConfig[normalizedType].Icon;
	const trimmedLast4 = last4?.trim();

	return (
		<span
			className={cn(
				"inline-flex items-center gap-1.5 text-sm font-medium text-textLight",
				className,
			)}
		>
			<Icon className="h-4 w-4 shrink-0 text-neutral-400" variant="dark" />
			<span className="uppercase">{normalizedType}</span>
			{trimmedLast4 && <span>•••• {trimmedLast4}</span>}
		</span>
	);
};

export default TransactionPaymentMethod;
